import { render, staticRenderFns } from "./widget_forum_search.vue?vue&type=template&id=849b0a92&scoped=true&"
import script from "./widget_forum_search.vue?vue&type=script&lang=js&"
export * from "./widget_forum_search.vue?vue&type=script&lang=js&"
import style0 from "./widget_forum_search.vue?vue&type=style&index=0&id=849b0a92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849b0a92",
  null
  
)

export default component.exports